import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import UploadButton from './UploadButton';
import UploadModal from './Modals';
import { NewVersionModal } from './Modals';
import '../../../Styles/Upload.scss';

const {
  actions: { toggleModal },
} = window.Edocat.Components.ModalTest;

interface UploadProps extends ReduxComponentInterface {
  disabled?: boolean; //for button
  path: string;
  disallowedExtensions: [];
  parentNodeRef?: string; //for button/modal
  multiple: boolean; //for button
  showButton: boolean;
  name: string; //for button/modal
  modal: any;
  callback: Function;
  component?: any;
  uploadAction?: (file: any) => {};
}

class Upload extends window.React.PureComponent<UploadProps> {
  render() {
    const {
      showButton,
      actions,
      disabled,
      multiple,
      modal,
      disallowedExtensions,
      parentNodeRef,
      path,
      name,
      callback,
      component,
      uploadAction,
    } = this.props;
    const pathArr = path?.split('/') || [];
    const site = pathArr.length > 0 ? pathArr[0] : '';
    const relativePath = pathArr.slice(2).join('/');
    return (
      <window.React.Fragment>
        {showButton && (
          <UploadButton
            toggleModal={actions.toggleModal}
            disabled={disabled}
            multiple={multiple}
            name={name}
            component={component}
          />
        )}
        {modal[name]?.isOpen && (
          <UploadModal
            disallowedExtensions={disallowedExtensions}
            parentNodeRef={parentNodeRef}
            site={site}
            path={relativePath}
            name={name}
            callback={callback}
            uploadAction={uploadAction}
          />
        )}
        {modal?.newVersionModal?.isOpen && (
          <NewVersionModal site={site} callback={callback} disallowedExtensions={disallowedExtensions} name={name} />
        )}
      </window.React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  modal: state.modal,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ toggleModal }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(Upload);
